import { MobileGameProfileVerification } from '../../game-profile/mobile/MobileGameProfileVerification.jsx';
import { CommunityTypePicker } from '../shared/CommunityTypePicker.jsx';
import { CurrentUnionSettings } from '../../game-profile/shared/CurrentUnionSettings.jsx';
import { DoroPartyWordmark } from '../../../shared/ui/DoroPartyWordmark.jsx';
import { SiteFooter } from '../../../shared/ui/SiteFooter.jsx';
import { SupabaseStatus } from '../../../shared/ui/SupabaseStatus.jsx';

function MobileHeader({ onSignOut }) {
  return (
    <header className="mobile-entry-topbar">
      <div className="mobile-entry-title"><DoroPartyWordmark compact /><span>개인 코드 계정</span></div>
      <SupabaseStatus compact />
      <button type="button" onClick={onSignOut} aria-label="로그아웃" title="로그아웃">↪</button>
    </header>
  );
}

function MobileChoice({ entry }) {
  const isAutoJoining = Boolean(entry.matchingUnion?.id);
  const canRegister = Boolean(entry.profile?.guild_name) && !entry.matchingUnion;
  return (
    <section className="mobile-entry-panel mobile-entry-choice" aria-label="유니온 연결">
      <div className="mobile-entry-heading"><div><p>UNION ONBOARDING</p><h1>{isAutoJoining ? '등록 유니온 자동가입' : '유니온 등록 신청'}</h1></div><b>02</b></div>
      <div className="mobile-entry-profile"><div><span>게임 계정</span><strong>{entry.profile?.nickname || '-'}</strong></div><div><span>유니온</span><strong>{entry.profile?.guild_name || '확인 필요'}</strong></div></div>
      {!entry.profile?.guild_id ? <p className="mobile-entry-notice warning">BlablaLink에서 유니온 소속을 확인한 뒤 다시 시도해주세요.</p> : null}
      {isAutoJoining ? (
        <article className="available"><span>AUTO JOIN</span><h2>{entry.matchingUnion.name} 연결 중</h2><p>게임에서 확인된 유니온이 이미 DoroParty에 등록되어 있어 자동으로 가입합니다.</p><button type="button" disabled>자동가입 처리 중…</button></article>
      ) : (
        <article className={canRegister ? 'available leader' : 'disabled'}><span>NEW UNION</span><h2>DoroParty 유니온 등록</h2><p>{entry.profile?.guild_name ? `${entry.profile.guild_name}이 아직 등록되지 않았습니다. 등록 승인 후 신청자가 주딱으로 시작합니다.` : '유니온명 확인이 필요합니다.'}</p>{canRegister ? <CommunityTypePicker idPrefix="mobile-entry" value={entry.communityType} onChange={entry.setCommunityType} disabled={Boolean(entry.working)} /> : null}<button type="button" disabled={!canRegister || !entry.communityType || Boolean(entry.working)} onClick={() => entry.registerNewUnion()}>{entry.working === 'registration' ? '등록 신청 중…' : !canRegister ? '등록 불가' : !entry.communityType ? '커뮤니티 유형 선택' : '유니온 등록 신청'}</button></article>
      )}
      {entry.notice.message ? <p className={`mobile-entry-notice ${entry.notice.type}`} role="status">{entry.notice.message}</p> : null}
      <button className="mobile-entry-refresh" type="button" onClick={() => entry.refresh()}>상태 다시 확인</button>
    </section>
  );
}

function MobilePending({ entry, blocked = false }) {
  const isLeader = entry.membership?.role === 'leader';
  return (
    <section className={`mobile-entry-panel mobile-entry-pending ${blocked ? 'blocked' : ''}`}>
      <div aria-hidden="true">{blocked ? '!' : '…'}</div><p>{blocked ? 'UNION STATUS' : 'WAITING FOR APPROVAL'}</p>
      <h1>{blocked ? '현재 유니온 페이지를 열 수 없습니다.' : isLeader ? '유니온 등록 승인 대기' : '유니온 가입 처리 대기'}</h1>
      <strong>{entry.union?.name || entry.profile?.guild_name || '유니온'}</strong>
      <span>{blocked ? '유니온 상태가 활성화되면 자동으로 정상 화면으로 이동합니다.' : '처리가 끝나면 자동으로 내 유니온 페이지로 이동합니다.'}</span>
      <button type="button" onClick={() => entry.refresh()}>지금 다시 확인</button>
    </section>
  );
}

export function MobileEntryGate({ onSignOut, entry }) {
  return (
    <div className="mobile-entry-shell">
      <MobileHeader onSignOut={onSignOut} />
      <main className="mobile-entry-main">
        {entry.mode === 'loading' ? <section className="mobile-entry-loading" role="status"><span aria-hidden="true" /><div><strong>계정 상태 확인 중</strong><p>프로필과 유니온 정보를 불러오고 있습니다.</p></div></section> : null}
        {entry.mode === 'error' ? <section className="mobile-entry-panel mobile-entry-error" role="alert"><strong>진입 정보를 확인하지 못했습니다.</strong><p>{entry.error}</p><button type="button" onClick={() => entry.refresh()}>다시 시도</button></section> : null}
        {entry.mode === 'profile' ? <><section className="mobile-entry-welcome"><p>STEP 01</p><h1>BlablaLink 인증</h1><span>게임 계정과 소속 유니온 확인 후 자동가입 또는 등록 신청으로 이어집니다.</span></section><MobileGameProfileVerification /></> : null}
        {entry.mode === 'onboarding' ? <MobileChoice entry={entry} /> : null}
        {entry.mode === 'pending' ? <MobilePending entry={entry} /> : null}
        {entry.mode === 'blocked' ? <MobilePending entry={entry} blocked /> : null}
        {entry.profile && ['pending', 'blocked', 'onboarding'].includes(entry.mode) ? <CurrentUnionSettings entry={entry} /> : null}
      </main>
      <SiteFooter compact />
    </div>
  );
}
